module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAACZM////yH5BAAHAP8ALAAAAAAMAAwAAAIUhI+pGx38TERtnWoBthte2GViUgAAOw=="